export class UserAccount {
  userId: any;
  firstName: string;
  lastName: string;
  emailAddress: string;
  roleId: number;
  roleName: string;
  isUserLoggedIn:boolean;
}
